import { useAsync } from "@atlassiansox/bxpkit-core";
import Environment from '../../../common/environment';

const LOCALE_CACHE_KEY = "bxp.currentLocale";
const DEFAULT_LOCALE = "US";
export const LOCALE_TO_CURRENCY = {
  US: "USD",
  JP: "JPY"
};

export default function useGeoCurrency(setCurrencyIsoCode) {
  return useAsync(() => {
    if (setCurrencyIsoCode) return Promise.resolve(setCurrencyIsoCode);

    const currentLocale = sessionStorage.getItem(LOCALE_CACHE_KEY);
    const localePromise = currentLocale
      ? Promise.resolve(currentLocale)
      : fetch(`${Environment.getWacIntegrationUrl()}/endpoint/location`)
        .then(response => response.json())
        .then(json => json.countryIsoCode || DEFAULT_LOCALE)
        .catch(() => DEFAULT_LOCALE);

    return localePromise.then(locale => {
      sessionStorage.setItem(LOCALE_CACHE_KEY, locale);
      return LOCALE_TO_CURRENCY[locale] || LOCALE_TO_CURRENCY[DEFAULT_LOCALE];
    });
  }, []);
}
